import { cn } from "@/lib/utils";
import { SAGE } from "@shared/brand";

/**
 * Shared required-field visual treatment (dashboard-flow-ux.md 3C/3D, G7).
 *
 * Defined ONCE here and applied across every surface that marks a required field
 * (expandable ribbon + drawer, card, table). The star color and the left-border
 * accent both live here so a future palette change is a one-line edit — no hunting
 * for repeated hex values.
 *
 * Sage 600 (#4F6B51) is the primary brand color (brand-guidelines.md) — "more
 * visible without being aggressive" per the 3C decision.
 */
export const REQUIRED_FIELD_COLOR = SAGE[600];

/** Left-border accent for required field cells/rows — the second scan-layer beyond
 *  the star (3D). Left-specific so it never overrides an existing full border. */
export const REQUIRED_FIELD_BORDER = "border-l-2 border-l-[#4F6B51]";

/**
 * The required-field marker (`*`). Decorative — `aria-hidden`; the field's own
 * required semantics carry the accessible meaning. Larger than body text (`text-lg`)
 * so it reads at a glance; pass `className` (e.g. a smaller `text-base`) to tune size
 * in tight contexts like the legend footnote.
 */
export function RequiredStar({ className }: { className?: string }) {
  return (
    <span
      className={cn("text-lg font-bold text-[#4F6B51] ml-0.5", className)}
      aria-hidden="true"
    >
      *
    </span>
  );
}
